<template>
  <div class="w-full">

      
      <template v-if="delivery.status === 'pending'">

          <div class="text-center w-full py-6 bg-red-600 text-white font-medium">
              <div class="text-2xl tracking-tight">{{ delivery.profile_name }}</div>
              <div class="text-lg"><a :href="`tel:${delivery.restaurant.phone}}`">
                  <PhoneFormatter :phone="delivery.restaurant.phone"></PhoneFormatter>
              </a></div>
          </div>


          <div class="mx-8 mt-8">

              <div class="mb-4">En saisissant cette commande, je m'engage en tant que service de courrier de:</div>

              <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Ramasser la commande dans des délais de 10-15 minutes après sa préparation</div></div>
              <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Livrer la commande dans des délais raisonnables pour assurer la fraîcheur des aliments</div></div>
              <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Communiquer avec un gérant si je ne peux respecter les points ci-hauts</div></div>
              <div class="flex items-start mb-1"><IconCheckOutline size="5" class="text-green-500 mr-2"></IconCheckOutline><div class="flex-1">Être courtois avec les restaurateurs, et la clientèle.</div></div>
              
          </div>
          
          <div v-if="grabbing" class="mx-6 py-3 my-12 text-center bg-indigo-600 text-white uppercase">
              <div class="inline-flex items-center">
              <IconClockOutline size="4" class="mr-2"></IconClockOutline>
              {{ _('Grab this request') }}...
              </div>
              </div>
          <div v-else @click="grab" class="mx-6 py-3 my-12 text-center bg-indigo-600 text-white uppercase">{{ _('Grab this request') }}</div>

          
          <p class="px-8 text-xs mb-4 italic">Advenant le non-respect des termes ci-hauts, je m'expose à un bris d'entente qui pourrait engendrer la suspension de la relation facturable avec LIVRO.CA INC. et retirer la capacité de réserver des quarts de livraison.</p>
          
      </template>
      <template v-else>

          <div class="text-center w-full py-6 bg-red-600 text-white font-medium">
              <div class="text-3xl">{{ _("ORDER") }} #{{ delivery.order_id }}</div>
          </div>


          <div class="rounded-md bg-green-100 mx-2 p-4 my-4">
              <div class="flex">
                  <div class="flex-shrink-0">
                      <!-- Heroicon name: check-circle -->
                      <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                      </svg>
                  </div>
                  <div class="ml-3">
                      <p class="text-sm font-medium text-green-800">
                          {{ _("Grabbed successfully") }}
                      </p>
                  </div>
                 
              </div>
          </div>
          
          
          <div class="mx-2 mb-8">
              <div class="bg-green-800 py-4 text-white text-center">
                  <div class="text-xl font-medium">
                      {{ delivery.profile_name }}
                  </div>

                  <div><a :href="`tel:${delivery.restaurant.phone}`">
                      <PhoneFormatter :phone="delivery.restaurant.phone"></PhoneFormatter>
                  </a></div>
                  
                  <div class="flex items-start px-4">
<!--                      <IconLocationMarkerOutline size="4" class="mr-2"></IconLocationMarkerOutline>-->
                      {{ delivery.restaurant.address }}</div>
                  
                  <div><a class="block text-center font-medium bg-white content-center text-green-800 mx-4 py-2 rounded mt-4" :href="mapurl(delivery.restaurant.address)">
                      <div class="inline-flex items-center">
                      <IconMapOutline size="5" class="mr-2"></IconMapOutline>
                      {{ _("GPS Directions") }}
                      </div>
                  </a></div>
              </div>
              
<!--              <div class="bg-gray-300 p-4">-->
<!--                  <div>Instructions:</div>-->
<!--                  <div>-->
<!--                      TOUJOURS VÉRIFIER LE # DE COMMANDE AVANT DE PRENDRE UN REPAS-->
<!--                      SI LE COMMERCE BROCHE UNE FACTURE AUTRE QUE LA NOTRE, VEUILLEZ LA RETIRER!-->
<!--                      COGNEZ À L'ANCIENNE VITRE DU DRIVE-THRU-->
<!--                      Assures-toi d'avoir la bonne commande.-->
<!--                      Poser une simple question avant de partir: Tout est là? Ustensiles, sauces et napkins? Faites-les réfléchir avant de partir.-->
<!--                      Quelconques problème en cours de route; contacter soit:-->
<!--                  </div>-->
<!--                  -->
<!--              </div>-->
              
              <div class="bg-blue-800 py-4 text-white text-center">
                  <div class="text-xl font-medium">Client</div>
                  <div><a :href="`tel:${delivery.customer_phone}}`">
                      <PhoneFormatter :phone="delivery.customer_phone"></PhoneFormatter>
                  </a></div>

                  <div class="flex items-start px-4">
<!--                      <IconLocationMarkerOutline size="4" class="mr-2"></IconLocationMarkerOutline>-->
                      <template>{{ delivery.customer_appartment }}</template>
                      {{ delivery.customer_address }}</div>



                  <div><a class="block text-center font-medium bg-white content-center text-blue-800 mx-4 py-2 rounded mt-4" :href="mapurl(delivery.customer_address)">
                      <div class="inline-flex items-center">
                          <IconMapOutline size="5" class="mr-2"></IconMapOutline>
                          {{ _("GPS Directions") }}
                      </div>
                  </a></div>
                  
              </div>
              
              <div class="bg-gray-300 p-4">
                  <div class="flex items-center justify-between"><div class="">{{_("Total Distance")}}:</div><div class="font-bold">{{ (delivery.distance/1000).toFixed(2) }}km</div></div>
                  <div class="flex items-center justify-between"><div class="">{{ _("This delivery is for") }}:</div><div class="font-bold">${{ delivery.driver_earning.toFixed(2) }} + tips</div></div>
                  
                  
                  <div class="flex items-center justify-between"><div class="">{{_("The client pays")}}:</div><div class="font-bold">${{ (delivery.order.grand_total - delivery.order.missing_amount).toFixed(2) }}</div></div>
                  <div class="flex items-center justify-between"><div class="">{{_("Payment Method")}}:</div><div class="font-bold">{{ delivery.order.payment_method }}</div></div>
              </div>
              
          </div>
          
      </template>
      
      <div class="border-t border-gray-600 pt-6">
      
      <div class="w-3/4 mx-auto mt-4">
          {{ _("Hey %s; you're logged in.").split("%s").join(driver.first_name) }}
          {{ _("If you're done for the day, please log out") }}
      </div>
      
      <div @click="logout" class="mx-6 py-3 my-8 text-center bg-red-600 text-white uppercase">{{ _("Logout") }}</div>

      </div>
      
      
  </div>
</template>

<script>
import PhoneFormatter from "../Shared/PhoneFormatter";
import {lang} from "../lang";
import IconClockOutline from "../../icons/outline/IconClockOutline";
import IconLocationMarkerOutline from "../../icons/outline/IconLocationMarkerOutline";
import IconMapOutline from "../../icons/outline/IconMapOutline";
import IconCheckOutline from "../../icons/outline/IconCheckOutline";
export default {
  name: "DriverPreview",
    components: {IconCheckOutline, IconMapOutline, IconLocationMarkerOutline, IconClockOutline, PhoneFormatter},
    props: [
        'delivery', 'driver', 'extras'
    ],
    data() {
      console.log(this.delivery);
        return {
            grabbing: false,
        }
    },
    
    methods: {
      
        grab() {
            if (this.grabbing) {
                return;
            }
            this.grabbing = true;  
            
            this.$inertia.post(this.$route('driver.delivery.grab', 
                {
                    driver: this.driver.id,
                    delivery: this.delivery.id,
                    ...this.extras
                }
            ))
        },
        
        mapurl(q) {
           if (this.driver.device_type === 'Android') {
               return 'geo:0,0?q=' + q;
           }  
           return 'https://www.google.com/maps/search/?api=1&dir_action=navigate&query=' + q;
        },
      
        _(k) {
            return lang(k, this.extras.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
        
        logout() {
            this.$inertia.post(this.$route('driver.offline', {driver: this.driver.id, token: this.driver.token, app_locale: this.extras.app_locale}));
        }
    }
}
</script>

<style scoped>

</style>
